import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ApiCallsService } from '../../../shared/services/network/api-calls.service';
import { NoWhitespaceValidator } from '../../../shared/validators/custom.validator';
import { api } from '../../../utils/endpoints';
interface DataItem {
  id: string;
  name: string;
  permissions?: Permission[]; // Optional because you plan to remove it
  permissionType: number;
}

interface Permission {
  name: string;
  permissionType: number;
  id: string;
}
@Component({
  selector: 'app-add-edit-data-space',
  templateUrl: './add-edit-data-space.component.html',
  styleUrl: './add-edit-data-space.component.scss',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgbDropdownModule],
})
export class AddEditDataSpaceComponent implements OnInit, OnDestroy {
  dataSpaceForm!: FormGroup;
  showError: boolean = false;
  private readonly unsubscribe$ = new Subject<void>();
  @Input() isEdit: boolean = false;
  @Input() addedData: any;
  selectedDataSpace: any;
  showSearchInput: boolean = false;
  searchCategory: string = '';

  constructor(
    private readonly _activeModal: NgbActiveModal,
    private readonly _toastr: ToastrService,
    private readonly _formBuilder: FormBuilder,
    private readonly _apiCalls: ApiCallsService,
  ) {}

  ngOnInit() {
    this.initializeForm();
    if (this.isEdit && this.addedData) {
      this.getDataSpaceDetails();
    }
  }

  private initializeForm(): void {
    this.dataSpaceForm = this._formBuilder.group({
      name: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(60),
          NoWhitespaceValidator,
        ],
      ],
      description: [
        null,
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(500),
          NoWhitespaceValidator,
        ],
      ],
    });
  }
  getDataSpaceDetails() {
    this.selectedDataSpace = this.addedData;
    this.dataSpaceForm.patchValue({
      name: this.selectedDataSpace.name,
      description: this.selectedDataSpace.description,
    });
  }

  createDataSpace() {
    if (this.dataSpaceForm.invalid) {
      this.showValidationMessage();
      return;
    }
    const requestBody = {
      ...this.dataSpaceForm.value,
    };
    if (this.isEdit == false) {
      this._apiCalls.post(api._dataSpaces, requestBody).subscribe({
        next: async (res: any) => {
          this.handleApiResponse(res);
        },
        error: (error: any) => {
          console.error('Error :', error);
        },
      });
    } else {
      this._apiCalls
        .put(`${api._dataSpaces + '/' + this.selectedDataSpace.id}`, requestBody)
        .subscribe({
          next: async (res: any) => {
            this.handleApiResponse(res);
          },
          error: (error: any) => {
            console.error('Error :', error);
          },
        });
    }
  }
  private async handleApiResponse(res: any): Promise<void> {
    try {
      const msg = this.isEdit ? 'updated' : 'created';
      this._toastr.success(`Dataspace ${msg} successfully.`);
      this.onClose(true);
    } catch (error) {
      console.error('Error while handling response:', error);
    }
  }

  private showValidationMessage(): void {
    const validationMessageDuration = 3000;
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, validationMessageDuration);
  }

  onClose(value: any): void {
    this._activeModal.close(value);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
